import React from 'react';
import { Checkbox } from './Checkbox.jsx';
import { Radio } from './Radio.jsx';
import { Toggle } from './Toggle.jsx';

/**
 * SelectionControl — Factory component for selection inputs.
 *
 * Renders a Checkbox, Radio, or Toggle based on the `type` prop.
 * Useful when the control type is dynamic (e.g. driven by config).
 *
 * All extra props are forwarded to the rendered control:
 *   checked, disabled, onChange, label, name, value, etc.
 *
 * @param {string} type - 'checkbox' | 'radio' | 'toggle'
 */
export const SelectionControl = ({ type = 'checkbox', ...props }) => {
    switch (type) {
        case 'checkbox':
            return <Checkbox {...props} />;
        case 'radio':
            return <Radio {...props} />;
        case 'toggle':
            return <Toggle {...props} />;
        default:
            console.warn(`Unknown SelectionControl type: ${type}`);
            return null;
    }
};

export default SelectionControl;